import ReactPaginate from 'react-paginate';
import GetIcon from '../../../utils/Icon';
const Pagination = ({setCurrentPage,totalrecords,pageSize}) => {

    const handlePageChange = (selectedPage) => {
        const page = selectedPage.selected + 1;
        setCurrentPage(page);
      };

  return (
    <>
    <ReactPaginate
          previousLabel={<GetIcon iconName="MdOutlineKeyboardDoubleArrowLeft" size={20}  />}
          nextLabel={<GetIcon iconName="MdOutlineKeyboardDoubleArrowRight" size={20}  />}
          breakLabel={"..."}
          pageCount={Math.ceil(totalrecords/ pageSize)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageChange}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
    </>
  )
}

export default Pagination